import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import dummySlotsData from "../assets/dummySlotsData.json";
import MakeBooking from "../components/MakeBooking";

const CalendarBookingView = () => {

    const fetchAndGroupSlots = async () => {
        const sheetId = "1EiyvC98fW3Gh1HGJ9koGNIBWwCW6VyeeufvXLAChQa0";
        const apiKey = "AIzaSyBONdBRy8yhtWC5eSW03YQkj8BcNN6goSA";
        const range = "Sheet1!A:K"; // Adjust based on columns

        const url = `https://sheets.googleapis.com/v4/spreadsheets/${sheetId}/values/${range}?key=${apiKey}`;

        const response = await fetch(url);
        const data = await response.json();

        // Convert data into structured format
        const headers = data?.values[0];
        const rows = data?.values.slice(1);

        // Aggregate slots by date
        const groupedData = rows.length > 0 && rows.reduce((acc, row) => {
            const date = row[1]; // Assuming Date is in column 2
            if (!acc[date]) acc[date] = { date, slots: [] };

            acc[date].slots.push({
                slotId: row[0],
                startTime: row[4],
                endTime: row[5],
                isGroupSlot: row[6] === "TRUE",
                isSlotFilled: row[7] === "TRUE",
                accommodationCount: row[8] || "Unlimited",
                focusArea: row[10] || "NA"
            });

            return acc;
        }, {});

        // Convert object into array
        return Object.values(groupedData).map(day => ({
            ...day,
            slotCount: day.slots.length, // Count slots for the day
        }));
    };


    const [slots,setSlots] = useState([]);

    useEffect(() => {
        const fetchSlots = async () => {
            const slotResults = await fetchAndGroupSlots();
            setSlots(slotResults);
        };

        fetchSlots();
    }, []);


    return <div className="calendar-booking-view">
        {
            slots && <MakeBooking slotsFromParent={slots} setSlotsFromParent={setSlots} slotsData={slots} fetchAndGroupSlots={fetchAndGroupSlots} />
        }
    </div>
}

export default CalendarBookingView;